import {
  addDomElementToHead,
  SUPABASE_ANON_KEY,
  SUPABASE_URL,
} from './utils'

export type User = {
  id: string
  firebase_id?: string
  email: string
  name?: string
  picture?: string
  active_group_id?: string
  supabase_auth?: any
  member_of_groups?: {
    id: string
    name: string
  }[]
}

export default class Auth {
  constructor() {
    this.authenticate()
  }

  async authenticate() {
    this.installAndAuthWithSupabase()
  }

  installAndAuthWithSupabase() {
    const scriptEl = addDomElementToHead('script', {
      src: 'https://cdn.jsdelivr.net/npm/@supabase/supabase-js@2',
      type: 'text/javascript',
      async: true,
      defer: true,
    }) as HTMLScriptElement
    scriptEl.onload = () => this.initSupabase()
  }

  async initSupabase() {
    window.supabaseClient = window.supabase.createClient(SUPABASE_URL, SUPABASE_ANON_KEY)

    window.dispatchEvent(new CustomEvent('savvy:supabase_client_ready', {}))
  }
}
